// extracted by mini-css-extract-plugin
export default {"RichText":"RichText-module__RichText--WqR87","primary":"RichText-module__primary--abA9c","tertiary":"RichText-module__tertiary--5oLcA"};